export default "__VITE_ASSET__Bhx7Qw_H__"